module.exports = __webpack_public_path__ + "static/media/fpsEn.98a3a06b.svg";